import React from 'react';
import { Helmet } from 'react-helmet-async';

export const SITE_NAME = 'Ambito Advogados';

export default function SEO({ title, description, canonical, image, type = 'website', jsonLd, noIndex = false }) {
  const fullTitle = title
    ? `${title} | ${SITE_NAME}`
    : `${SITE_NAME} - Encontre o advogado certo para a sua causa`;
  const desc = description || 'Ambito Advogados, a plataforma de advogados do Âmbito Jurídico. Compare escritórios de advocacia reais por cidade e área de atuação.';
  const url = canonical || (typeof window !== 'undefined' ? window.location.href : '');
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  const img = image ? (image.startsWith('/') ? origin + image : image) : `${origin}/og-default.png`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      {url && <link rel="canonical" href={url} />}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      {url && <meta property="og:url" content={url} />}
      {img && <meta property="og:image" content={img} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      {img && <meta name="twitter:image" content={img} />}
      <meta name="robots" content={noIndex ? 'noindex, nofollow' : 'index, follow, max-image-preview:large'} />
      <html lang="pt-BR" />
      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
}
